module.exports = __webpack_public_path__ + "img/wximg24.ec6cf489.png";